module.exports = {

  title: 'SPS',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

   /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
    tagsView: true,
    /**
     * 环境（17：dev  沙箱：test  正式：prod）
     */
    env:'dev',
}
